export default {
  100: 'new',
  101: 'paying',
  102: 'confirming',
  103: 'success',
  104: 'failed',
}
